import { isDeadlineUxCopyChangeEnabled } from 'bundles/goal-setting/components/unified-goals/utils/featureGates';
import type { FormattedLockMessageOptions } from 'bundles/learner-progress/utils/Item';

export function shouldShowExperimentalUxCopyChangeLockMessage({
  itemLockedReasonCode,
  sessionsV2Enabled = false,
  isScheduleIncentivesEnabled = false,
  scheduleSuggestionsAvailable = true,
}: FormattedLockMessageOptions): boolean {
  const hasDeadlineUxCopyChangeEnabled = isDeadlineUxCopyChangeEnabled();

  return (
    scheduleSuggestionsAvailable &&
    sessionsV2Enabled &&
    !isScheduleIncentivesEnabled &&
    itemLockedReasonCode === 'SESSION_ENDED' &&
    hasDeadlineUxCopyChangeEnabled
  );
}
